// @flow
import { createAction } from 'redux-act';

export const setPositions = createAction('Set Positions');